import { render, staticRenderFns } from "./PeriodicPerformance.vue?vue&type=template&id=453df037&"
import script from "./PeriodicPerformance.vue?vue&type=script&lang=js&"
export * from "./PeriodicPerformance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports